export default __webpack_public_path__ + "static/media/quickswap_logo.80705890.jpg";